/**
 * An aside — a clarification the reader needs at this point, not a status.
 *
 * Deliberately not a `Badge` or an alert: those carry semantic colour, and this
 * is neither good news nor bad. It sits on the page's own off-white so it reads
 * as a footnote to the card it is in rather than as a warning about it. Using a
 * semantic tint here would spend a colour that PRD §9.2 reserves for status.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 6.5.9, §4.2
 */
import { cn } from '../../lib/cn';

export interface NoteProps {
  children: React.ReactNode;
  className?: string;
}

export function Note({ children, className }: NoteProps): React.JSX.Element {
  return (
    <p
      className={cn(
        'bg-off-white text-body rounded-md px-3.5 py-3 text-xs leading-relaxed font-light',
        className,
      )}
    >
      {children}
    </p>
  );
}
